import { FormControlProps } from "@mui/material";
import { FC, ReactElement } from "react";
import { BlockLabel, BlockWithLabelRoot } from "./BlockWithLabel.styles";

const BlockWithLabel: FC<
	{ label?: string; labelButton?: ReactElement; labelColor?: string; labelMarginLeft?: string; labelPosition?: "left" | "right" } & FormControlProps
> = ({ children, labelColor = "", labelButton = <></>, label = "", labelPosition = "left", labelMarginLeft = "-8px", ...props }) => {
	return (
		<BlockWithLabelRoot component="fieldset" variant="outlined" {...props}>
			{/* @ts-expect-error */}
			<BlockLabel component="legend" sx={{ textAlign: labelPosition, color: labelColor, marginLeft: labelMarginLeft, display: "flex", flexDirection: "row" }}>
				{label}
				<div style={{ marginLeft: "8px" }}>{labelButton}</div>
			</BlockLabel>
			{children}
		</BlockWithLabelRoot>
	);
};

export default BlockWithLabel;
